import { takeEvery } from 'redux-saga/effects';
import Services from 'services';
import types from 'redux/types';
import { V2_LOGOUT_URL } from 'consts/api';
import { AppRoutes } from 'consts/routesPath';
import userServices from 'services/userServices';

const { REQUEST_API_LOGOUT } = types;

function postLogout({ callbacks } = {}) {
  try {
    Services.post(V2_LOGOUT_URL);
    Services.removeInterceptors();

    callbacks && callbacks.onSuccess();
    userServices.clearUserCached();

    window.location.href = AppRoutes.Login;
  } catch (error) {
    callbacks && callbacks.onFailed();
  }
}

export default function* watchGetAPIFunction() {
  yield takeEvery(REQUEST_API_LOGOUT, postLogout);
}
